
import { useState } from "react";

import { useNavigate } from "react-router";

import { Grid, Grow, Card, CardActionArea, CardMedia, CardContent, Typography } from "@mui/material"

import { Layout } from "../../components/Layout"

import { DialogCatalogos } from "../../dialogs/DialogCatalogos"

export const HomePage = () => {  
     
    const navigate = useNavigate();

    const [open, setOpen] = useState(false);

    return (

        <Layout breadcrumbs={[ { text: 'Administración' } ]} backgroundPaper={ false }>

            <Grid container spacing={3}>

                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>

                    <Grow
                        in={true}
                        style={{ transformOrigin: '0 0 0' }}
                        {...(true ? { timeout: 1000 } : {})}
                    >

                        <Card>

                            <CardActionArea onClick={ () => navigate( '/usuarios/' ) }>

                                <CardMedia
                                    component="img"
                                    height="240"
                                    image={ process.env.PUBLIC_URL + '/assets/usuarios.png' }
                                    alt={ "catalogos" }
                                    sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                />

                                <CardContent>

                                    <Typography gutterBottom variant="h6" component="div">
                                        Usuarios
                                    </Typography>   

                                </CardContent>
                                
                            </CardActionArea>                        

                        </Card>

                    </Grow>

                </Grid> 

                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>

                    <Grow
                        in={true}
                        style={{ transformOrigin: '0 0 0' }}
                        {...(true ? { timeout: 1000 } : {})}
                    >

                        <Card>

                            <CardActionArea onClick={ () => setOpen( true ) }>

                                <CardMedia
                                    component="img"
                                    height="240"
                                    image={ process.env.PUBLIC_URL + '/assets/catalogos.png' }
                                    alt={ "catalogos" }
                                    sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                />

                                <CardContent>

                                    <Typography gutterBottom variant="h6" component="div">
                                        Catálogos
                                    </Typography>   

                                </CardContent>     

                            </CardActionArea>

                        </Card>

                    </Grow>

                </Grid> 
                
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>

                    <Grow
                        in={true}
                        style={{ transformOrigin: '0 0 0' }}
                        {...(true ? { timeout: 1000 } : {})}
                    >

                        <Card>

                            <CardActionArea onClick={ () => navigate( '/apikeys/' ) }>

                                <CardMedia
                                    component="img"
                                    height="240"
                                    image={ process.env.PUBLIC_URL + '/assets/apikeys.png' }
                                    alt={ "catalogos" }
                                    sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                />

                                <CardContent>

                                    <Typography gutterBottom variant="h6" component="div">
                                        Api Key´s
                                    </Typography>   

                                </CardContent>
                                
                            </CardActionArea>                        

                        </Card>

                    </Grow>

                </Grid>                
               
                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>

                    <Grow
                        in={true}
                        style={{ transformOrigin: '0 0 0' }}
                        {...(true ? { timeout: 1000 } : {})}
                    >

                        <Card>

                            <CardActionArea onClick={ () => navigate( '/registros-accesos/' ) }>

                                <CardMedia
                                    component="img"
                                    height="240"
                                    image={ process.env.PUBLIC_URL + '/assets/registros.png' }
                                    alt={ "catalogos" }
                                    sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                />

                                <CardContent>

                                    <Typography gutterBottom variant="h6" component="div">
                                        Registros de acceso
                                    </Typography>   

                                </CardContent>
                                
                            </CardActionArea>                        

                        </Card>

                    </Grow>

                </Grid>   

                <Grid size={{ xs: 12, sm: 6, lg: 4 }}>

                    <Grow
                        in={true}
                        style={{ transformOrigin: '0 0 0' }}
                        {...(true ? { timeout: 1000 } : {})}
                    >

                        <Card>

                            <CardActionArea onClick={ () => navigate( '/dispositivos/' ) }>

                                <CardMedia
                                    component="img"
                                    height="240"
                                    image={ process.env.PUBLIC_URL + '/assets/dispositivos.png' }
                                    alt={ "catalogos" }
                                    sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                />

                                <CardContent>

                                    <Typography gutterBottom variant="h6" component="div">
                                        Control de dispositivos
                                    </Typography>   

                                </CardContent>
                                
                            </CardActionArea>                        

                        </Card>

                    </Grow>

                </Grid>   
    
            </Grid>     

            <DialogCatalogos
                id="catalogos-menu"
                keepMounted
                open={open}
                onClose={ () => setOpen( false ) }
            /> 
            
        </Layout>  
    )
}
